import { InsureeDataFromSasis } from "@/modules/admin/sasis-lookup/services/insureeDataFromSasisByHealthInsuranceCardNumberQuery"

export const LOOKUP_MODES = ["veka", "insureeNumber", "nameAndDateOfBirth", "ahv"] as const

export type ViewMode = "mapped" | "raw"

export type LookupResultEntry = {
  entryKey: string
  organisationName: string | null
  mapped: InsureeDataFromSasis["mapped"]
  rawXml: string | null
  returnCode: string | null
  returnMessage: string | null
  errorMessage: string | null
}
